var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('question-title',{staticClass:"mb2",attrs:{"question":_vm.question}}),_vm._l((_vm.question.fields),function(field){return _c('button',{key:field.choice,class:[
        'button',
        'is-fullwidth',
        'mb1',
        { 'is-primary': _vm.choice === field.choice }
      ],on:{"click":function($event){return _vm.recordAnswer(field.choice)}}},[_vm._v("\n      "+_vm._s(field.choice)+"\n    ")])}),_c('next-button',{ref:"nextButton",attrs:{"id":_vm.question.id,"choice":_vm.choice}})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }